exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ZnuZACcG4BpFxM_swewwv{width:380px}.Pk8Hfn6J_W6DXwsg93Wk{font-size:12px;font-weight:400}html[dir=ltr] ._3-lg6qFzAX3BZixYbyTsaA .ms-ContextualMenu-link{padding-left:40px}html[dir=rtl] ._3-lg6qFzAX3BZixYbyTsaA .ms-ContextualMenu-link{padding-right:40px}", ""]);

// exports
exports.locals = {
	"fixWidthContextMenu": "ZnuZACcG4BpFxM_swewwv",
	"smallFontContextMenu": "Pk8Hfn6J_W6DXwsg93Wk",
	"conditionalPadding": "_3-lg6qFzAX3BZixYbyTsaA"
};